import { FC, memo, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { GradientWrapper, Chevron } from './max.styled';
import { Text, Button } from '../../components-v4';
import { ReactComponent as MaxIcon } from '../../assets/max-icon.svg';
import { BannerSkeleton } from '../skeletons';
import { getOnLoadPublicRequestState } from '../../selectors';
import { MIN_SKELETON_DURATION } from '../../constants';

type Props = {
  inHeader?: boolean;
};

export const Max: FC<Props> = memo(({ inHeader }) => {
  const onLoadRequest = useSelector(getOnLoadPublicRequestState);
  const [showSkeleton, setShowSkeleton] = useState<boolean>(onLoadRequest);
  const loadStartRef = useRef<number | null>(onLoadRequest ? Date.now() : null);

  useEffect(() => {
    if (onLoadRequest) {
      loadStartRef.current = Date.now();
      setShowSkeleton(true);
    } else if (loadStartRef.current !== null) {
      const elapsed = Date.now() - loadStartRef.current;
      const remaining = MIN_SKELETON_DURATION - elapsed;

      if (remaining > 0) {
        const timer = setTimeout(() => setShowSkeleton(false), remaining);
        return () => clearTimeout(timer);
      }

      setShowSkeleton(false);
    }
  }, [onLoadRequest]);

  const handleGo = () => {
    const link = document.createElement('a');
    link.href = `https://max.ru/id7806206017_bot`;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.click();
  };

  if (inHeader) {
    return (
      <Button
        mode="accent"
        variant="ghost"
        size="s"
        onClick={handleGo}
        leftIcon={<MaxIcon />}
      >
        Бот в MAX
      </Button>
    );
  }

  if (showSkeleton) {
    return (
      <div>
        <BannerSkeleton />
      </div>
    );
  }

  return (
    <GradientWrapper onClick={handleGo}>
      <Text variant="body-16" color="white">
        Чат-бот «Арсений» в MAX
      </Text>
      <Chevron />
    </GradientWrapper>
  );
});
